import(/* webpackMode: "eager" */ "/builds/southchip/official/node_modules/.pnpm/next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.71.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/node_modules/.pnpm/next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.71.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/node_modules/.pnpm/next@14.2.23_@babel+core@7.23.6_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.71.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/AboutCompany.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/ComplianceConstruction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/CorporateHonor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/EnterpriseScale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/ResearchInnovation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/AboutUs/WhyChoose.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Graphs"] */ "/builds/southchip/official/src/components/blocks/Application/ApplicationGraphs/Graphs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Application/ApplicationOverview/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Application/CaseOverview/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Application/CaseProduct/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Application/CaseTechnical/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ArticleCover/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/BusinessConsult/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/blocks/CommonBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/CommonNewProduct/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ContactUs/ContactOffice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Feedback/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Footer/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/GlobalSearch/search-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/GlobalSearch/search-input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalSearch"] */ "/builds/southchip/official/src/components/blocks/Header/GlobalSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverItem"] */ "/builds/southchip/official/src/components/blocks/Header/Hover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/MobileNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/builds/southchip/official/src/components/blocks/Header/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pannel"] */ "/builds/southchip/official/src/components/blocks/Header/Pannel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteSelect"] */ "/builds/southchip/official/src/components/blocks/Header/SiteSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Header/UserInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Home/CompanyIntroduction/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Home/NewProduct/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Home/ProductOverview/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Home/SolutionAndCase/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/NewsCover/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/NewsDetail/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/PageTabsContent/HashContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductCategory/ApplicationCasesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductCategory/FeatureApplicationClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductCategory/Industry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductCategory/ProductSelectorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductDetails/Application.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductDetails/Datasheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductDetails/Document.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductDetails/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/ProductsCompare/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/QualityReliability/EnvDeclaration/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/QualityReliability/QualityOverview/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/QualityReliability/ReliabilityTerminology/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/QualityReliability/ReliabilityTesting/newClient.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/blocks/Richtext/ckeditorTheme.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/SampleRequest/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/TabsBanner/TabsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabsFilterClient"] */ "/builds/southchip/official/src/components/blocks/TabsFilter/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/TechFileDownload/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/Title/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/UserLayout/ForgetPassword.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/UserLayout/Login.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/blocks/UserLayout/Register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreviewNotice"] */ "/builds/southchip/official/src/components/clients/PreviewNotice.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/DevTool/Inspect.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/DevTool/Toolbar.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/DirectusImage/default_cover.png");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/ui/client-href.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/ui/close-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogPortal","DialogOverlay","DialogContent","DialogClose"] */ "/builds/southchip/official/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/ui/infinite-moving.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/southchip/official/src/components/ui/pagination.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/ui/router-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/builds/southchip/official/src/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/builds/southchip/official/src/components/ui/title.tsx");
